<template>
  <div v-if="ay_list != null">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Copy Offered Subject</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container>
        <v-row dense>
          <v-col cols="12" sm="5" md="5" style="text-align: right">
            <v-combobox rounded dense required return-object v-model="from_ay" :items="ay_list" item-text="ay"
              label="From Academic Year" outlined />
          </v-col>
          <v-col cols="12" sm="2" md="2" style="text-align: center">
            <v-btn text color="#0f2027" :loading="copy_btn_load">
              <v-icon large color="#0f2027">mdi-arrow-right-bold-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="5" md="5" style="text-align: left">
            <v-combobox rounded dense required v-model="to_ay" return-object :items="ay_list" item-text="ay"
              label="To Academic Year" outlined />
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-col cols="12" sm="5" md="5" style="text-align: left">
            <v-combobox rounded dense required v-model="standard" return-object :items="standard_list"
              item-text="standard" label="Select Standard" @change="onStandardChange" outlined />
          </v-col>
        </v-row>
        <v-row dense justify="center">
          <v-btn v-if="standard && to_ay" class="button" @click="getSubject()">Fetch</v-btn>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="box" v-if="subject_list != ''">
      <v-data-table v-model="selectedTasks" item-key="coff_id" :single-select="singleSelect" show-select
        :headers="headers" :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search"
        @current-items="getFiltered" :items-per-page="-1">
        <template v-slot:top class="pb-5">
          <v-row justify="center" align="center">
            <tr class="t-row">
              <div>
                <th>
                  <v-row>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                          color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                          v-model="filters[header.value]"></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </th>
              </div>
            </tr>
          </v-row>
        </template>
        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
      </v-data-table>
      <v-row dense justify="center">
        <v-btn :loading="copy_offer_btn_load" class="button" @click="copySubject()">Copy</v-btn>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";

import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    ay_list: null,
    to_ay: null,
    from_ay: null,
    from_slot_list: null,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    to_slot_list: null,
    search: "",
    copy_btn_load: false,
    standard_list: [],
    singleSelect: false,
    selectedTasks: [],
    standard: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    filterArr: [],
    copy_offer_btn_load: false,
    filters: {
      subjectcode: [],
      subject: [],
    },
    subject_list: [],
    headers: [
      { text: "Sr. No.", value: "srno" },
      { text: "Subject Code", value: "subjectcode" },
      { text: "Subject", value: "subject" },
      { text: "Subject Rule", value: "subjectrule" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Standard", value: "standard" },
      { text: "Subject Type", value: "subjecttype" },
      { text: "Mark Entry Type", value: "entrytype" },
      { text: "Credit", value: "credit" },
      { text: "Status", value: "isactive" },
    ],
  }),
  computed: {
    bookList1() {
      return this.subject_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.subject_list.map((d) => d[val]);
    },
    onStandardChange(){
      this.subject_list = [];
    },
    onLoad() {
      axios
        .post("/Examination/getInitialData")
        .then((res) => {
          // this.to_ay = res.data.curreny_ay;
          this.ay_list = res.data.ay_list;
          // this.from_ay = res.data.curreny_ay;
          this.standard_list = res.data.standard_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.copy_offer_btn_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    copySubject() {
      if (this.selectedTasks == "") {
        this.showSnackbar("#b71c1c", "Please select Subject");
      }
      // console.log(this.selectedTasks,)
      this.copy_offer_btn_load = true;
      const data = {
        course_id: this.selectedTasks,
        from_ay: this.from_ay.id,
        to_ay: this.to_ay.id,
        standard: this.standard.id,
      };
      axios
        .post("/Examination/copySubject", data)
        .then((res) => {
          this.showSnackbar("#4caf50", "Subject Copied Successfully...");
          this.copy_offer_btn_load = false;
          this.subject_list = [];
          this.singleSelect = false;
          this.selectedTasks = [];
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.copy_offer_btn_load = false;
          this.subject_list = [];
          this.singleSelect = false;
          this.selectedTasks = [];
          this.standard = null;
          this.to_ay = null;
          this.from_ay = null;
        });
    },
    getSubject() {
      this.subject_list = [];
      if (this.from_ay.id == this.to_ay.id) {
        this.showSnackbar(
          "#b71c1c",
          "From and To Academic year cannot be same!!!..."
        );
        return;
      }
      const formData = {
        from_ay: this.from_ay,
        standard: this.standard,
      };
      axios
        .post("/Examination/getSubject", formData)
        .then((res) => {
          this.subject_list = res.data.subject_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.copy_offer_btn_load = false;
        });
    },
  },
  mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
</style>
